import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Row } from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIupdateCollectionsOrder } from '../../api/Collections';

import { swapCollections as swapCollectionsAction } from '../../actions/Collections';

import { userCan } from '../../helpers/Auth';
import { getParentCollection } from '../../helpers/Collections';
import { addFlashMessage } from '../../helpers/FlashMessages';
import withDragAndDropContext from '../../helpers/withDragAndDropContext';

import CollectionsGridItem from './GridItemV2';

class CollectionsGrid extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      movedMenuItem: null,
    };

    this.moveCollection = this.moveCollection.bind(this);
    this.saveCollections = this.saveCollections.bind(this);
  }

  moveCollection(dragIndex, hoverIndex) {
    const {
      swapCollections,
      reorderingMode,
    } = this.props;

    if (reorderingMode) {
      swapCollections(dragIndex, hoverIndex);
    }
  }

  saveCollections(dragIndex) {
    const { intl, collections } = this.props;

    const parentCollection = getParentCollection(collections[0]);
    this.setState({ movedMenuItem: dragIndex });
    APIupdateCollectionsOrder(
      parentCollection ? parentCollection.uuid : null,
      collections.map(c => (c.uuid)),
    ).then(() => {
      this.setState({ movedMenuItem: null });
    }).catch(() => {
      this.setState({ movedMenuItem: null });
      addFlashMessage({
        type: 'danger',
        text: intl.formatMessage({ defaultMessage: 'Something went wrong' }),
      });
    });
  }

  render() {
    const {
      collections,
      reorderingMode,
      className,
      canDrag,
      handleMoveSelectedItems,
    } = this.props;
    const { movedMenuItem } = this.state;

    return (
      <Row
        className={classnames(
          'gutter-20',
          'collections',
          className,
          { reordering: reorderingMode },
        )}
      >
        {collections.map(c => (
          <CollectionsGridItem
            id={c.uuid}
            index={c.uuid}
            key={c.uuid}
            collection={c}
            moveCollection={this.moveCollection}
            saveCollections={this.saveCollections}
            handleMoveSelectedItems={handleMoveSelectedItems}
            isMoved={movedMenuItem === c.uuid}
            {...this.props}
            canDrag={canDrag && userCan('collection.edit', c)}
          />
        ))}
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  reorderingMode: state.Files.reorderingMode,
});

const mapDispatchToProps = dispatch => ({
  swapCollections: (firstItem, secondItem) => {
    dispatch(swapCollectionsAction(firstItem, secondItem));
  },
});

CollectionsGrid.propTypes = {
  intl: PropTypes.object.isRequired,
  reorderingMode: PropTypes.bool.isRequired,
  swapCollections: PropTypes.func.isRequired,
  handleMoveSelectedItems: PropTypes.func,
  collections: PropTypes.array.isRequired,
  className: PropTypes.string,
  canDrag: PropTypes.bool,
  renderDisplayAction: PropTypes.func,
  selectedView: PropTypes.string,
};

CollectionsGrid.defaultProps = {
  handleMoveSelectedItems: () => {},
  className: '',
  canDrag: true,
  renderDisplayAction: null,
  selectedView: null,
};

export default withDragAndDropContext(
  injectIntl(connect(mapStateToProps, mapDispatchToProps)(CollectionsGrid)),
);
